import microuniversoApi from "app/api/microuniversoApi";
import { IColuna } from "app/types/IColuna";
import { Parametro, ParametroPorItem } from "app/types/Parametro";
import { DadosDaPesquisaOrcamento, DadosPesquisaOrcamento, DadosTotalDaPesquisaOrcamento, FiltroPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { substituirItemEmArray } from "substituirItemEmArray";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { PerfilButtonContainer } from "../perfil-button/PerfilButtonContainer";
import { PesquisarClienteContainer } from "../pesquisa-cliente/PesquisarClienteContainer";
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { SenhaVendedorContainerDialog } from "../senha-vendedor/SenhaVendedorContainerDialog";
import { useMenuConsultasPesquisaOrcamento } from "./menu-consultas-pesquisa-orcamento/useMenuConsultasPesquisaOrcamento";
import { PesquisaOrcamento } from "./PesquisaOrcamento";
import { CancelarOrcamentoContainer } from "./cancelar-orcamento/CancelarOrcamentoContainer";
import { TrocarFilialOrcamentoContainer } from "./trocar-filial-orcamento/TrocarFilialOrcamentoContainer";
import { ModalImprimirContainer, PermissaoSenhaModalImprimirProps } from "../itens-orcamento/orcamento-concluido/modal-imprimir/modalImprimirContainer";
import { FiltrosListarTemplateSeguranca, PermissoesImpressao } from "app/types/modalImprimir/RespostaModalImprimir";
import { AlterarValidadePedidoContainer } from "../AlterarValidadePedido/AlterarValidadePedidoContainer";
import { VendedorBase, Vendedor } from "app/types/Vendedor";

declare var window: any

export type PesquisaOrcamentoContainerProps = {
    filtroPesquisaOrcamento?: Partial<FiltroPesquisaOrcamento>
    retornarPesquisar?: boolean
    orcamentoSelecionado?: Partial<DadosDaPesquisaOrcamento>
}
export const PesquisaOrcamentoContainer = (props: PesquisaOrcamentoContainerProps) => {
    const nomeGrid =  "PESQUISAR_ORCAMENTO_DETALHES"

    const [dadosPesquisaOrcamento, setDadosPesquisaOrcamento] = useState<Partial<DadosPesquisaOrcamento>>({})
    const [filtroPesquisaOrcamento, setFiltroPesquisaOrcamento] = useState<Partial<FiltroPesquisaOrcamento>>(props.filtroPesquisaOrcamento ?? {})
    const [colunas, setColunas] = useState<IColuna[]>([]);
    const [permissoesImpressao, setPermissoesImpressao] = useState<PermissoesImpressao>({})
    const [parametros, setParametros] = useState<Parametro[]>([]);
    const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([]) // 450413
    const [orcamentoSelecionado, setOrcamentoSelecionado] = useState<Partial<DadosDaPesquisaOrcamento>>(props.orcamentoSelecionado ?? null)
    const [dadosPesquisa, setDadosPesquisa] = useState<Partial<DadosTotalDaPesquisaOrcamento>>({})
    const [processando, setProcessando] = useState<boolean>(false);
    const [tamanhoFonte, setTamanhoFonte] = useState<number>(0);
    const [oidUsuarioLogado, setOidUsuarioLogado] = useState<number>(0)
    const [oidFilialUsuarioLogado, setOidFilialUsuarioLogado] = useState<number>(0) // 488824
    const [vendedorGerente, setVendedorGerente] = useState<boolean>(null) //444713
    const [codigoFilialUsuarioLogado, setCodigoFilialUsuarioLogado] = useState<string>(null) // 476918

    const [permiteEngrenagemGrid, setPermiteEngrenagemGrid] = useState(false)
    const [permitirTrocarFilial, setPermitirTrocarFilial] = useState(false) // é o botao "tracarFilial"
    const [permitirAlterarValidadeOrcamento, setPermitirAlterarValidadeOrcamento] = useState(false) // 456674
    const [permitirAlterarSemRecalcularPreco, setPermitirAlterarSemRecalcularPreco] = useState(false) // 455487
    const [permitirImprimir, setPermitirImprimir] = useState(false)
    const [dadosCarregados, setDadosCarregados] = useState<boolean>(false)
    const [mostrarModalImprimir, setMostrarModalImprimir] = useState<boolean>(false);
    const [permissaoSenhaModalImprimir, setPermissaoSenhaModalImprimir] = useState<PermissaoSenhaModalImprimirProps>(null) // 450413

    const passosInterno = useRef<Dict<string, () => void>>(new Dict())
    const isMounted = useRef<boolean>(true);
    const dadosIniciaisGridSolicitados = useRef<boolean>(false);
    const buscouPermissaoFuncionalidadeAcao = useRef<boolean>(false);

    const token: string = globalMU.token();

    const tableRef = useRef(null);

    const permitidoAcaoFuncionalidade = async (siglaFuncionalidade: string, acao?: string) => await obterPermissao({ funcionalidade: siglaFuncionalidade, acao });

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    const atualizarParametros = async () => {
        if (!isMounted.current) return
        const result = await obterParametros({
            nomes: [
                //"SOLICITAR_SENHA_TROCA_FILIAL_ORCAMENTO",
                "PEDE_SENHA_A_CADA_ORCAMENTO",
                "DESTACAR_PENDENCIA_ESTOQUE_CONSULTA_ORCAMENTO",
                //"EXIBIR_ORCAMENTOS_UNIFICADOS_CONSULTA_ORC",
                //"HABILITAR_DUPLICACAO_ORCAMENTO",
                //"UTILIZA_CODBARRA_CONFERENCIA_SAIDA"
            ],
        })
        if (!isMounted.current) return
        setParametros(result)
    }

    const atualizarParametrosPorFilial = async () => {
        if (!isMounted.current) return
        const result = await obterParametrosPorOidItem({ // 433263
            nomes: [
                "SOLICITAR_AUTORIZACAO_IMPRESSAO_ORCAMENTO_DESCONTO_ACIMA_PERMITIDO",
                "UTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA", // 487678
                "HABILITAR_DUPLICACAO_ORCAMENTO",
                "SOLICITAR_SENHA_TROCA_FILIAL_ORCAMENTO",
                "EXIBIR_ORCAMENTOS_UNIFICADOS_CONSULTA_ORC",
                "TRABALHA_COBRANCA_PIX_PRAZO", //414608
                "WEBSERVICE_URL_API_ENTERPRISE", //414608
                "UTILIZA_CODBARRA_CONFERENCIA_SAIDA"
            ],
            oidItem: orcamentoSelecionado?.OidFilial ?? oidFilialUsuarioLogado
        })
        if (!isMounted.current) return
        setParametrosPorFilial(result)
    }

    const valorParametroPorFilial = (nome: string) => parametrosPorFilial.find((p) => p.Nome == nome)?.Valor; // 450413

    const obterPermissaoImpressao = async () => {
        if (!isMounted.current) return
        const [
            permissaoImprimir,
            permitidoEnviarEmail,
            permitidoImprimirWord,
            permitidoAlterarAssuntoEmail,
            permitidoAlterarCopiaEmail,
            permitidoAlterarCopiaOcultaEmail,
            permitidoAlterarMensagemEmail,
            permitidoAnexarEmail,
        ] = await Promise.all([
            microuniversoApi.PermissaoFuncionalidade.obterUsuarioPermitidoFuncionalidadeAcao("ORCAMENTO_FINALIZAR", ["IMPRIMIR_ORCAMENTO"]),
            microuniversoApi.PermissaoFuncionalidade.obterUsuarioPermitidoFuncionalidadeAcao("ORCAMENTO_FINALIZAR", ["PERMITIR_ENVIAR_EMAIL"]),
            microuniversoApi.PermissaoFuncionalidade.obterUsuarioPermitidoFuncionalidadeAcao("ORCAMENTO_FINALIZAR", ["PERMITIR_IMPRIMIR_WORD"]),
            microuniversoApi.PermissaoFuncionalidade.obterUsuarioPermitidoFuncionalidadeAcao("ORCAMENTO_FINALIZAR", ["PERMITIR_ALTERAR_ASSUNTO_EMAIL"]),
            microuniversoApi.PermissaoFuncionalidade.obterUsuarioPermitidoFuncionalidadeAcao("ORCAMENTO_FINALIZAR", ["PERMITIR_ALTERAR_COPIA_EMAIL"]),
            microuniversoApi.PermissaoFuncionalidade.obterUsuarioPermitidoFuncionalidadeAcao("ORCAMENTO_FINALIZAR", ["PERMITIR_ALTERAR_COPIA_OCULTA_EMAIL"]),
            microuniversoApi.PermissaoFuncionalidade.obterUsuarioPermitidoFuncionalidadeAcao("ORCAMENTO_FINALIZAR", ["PERMITIR_ALTERAR_MENSAGEM_EMAIL"]),
            microuniversoApi.PermissaoFuncionalidade.obterUsuarioPermitidoFuncionalidadeAcao("ORCAMENTO_FINALIZAR", ["PERMITIR_ANEXAR_ARQUIVOS_EMAIL"]),
        ])
        if (!isMounted.current) return
        setPermissoesImpressao({
            permitidoEnviarEmail,
            permitidoImprimirWord,
            permitidoAlterarCopiaEmail,
            permitidoAlterarCopiaOcultaEmail,
            permitidoAlterarAssuntoEmail,
            permitidoAlterarMensagemEmail,
            permitidoAnexarEmail,
        })
        setPermitirImprimir(permissaoImprimir)
    };

    const buscarPermissaoFuncionalidadeAcao = async () => {
         if (!isMounted.current || buscouPermissaoFuncionalidadeAcao.current) return

        buscouPermissaoFuncionalidadeAcao.current = true;
        
        if (!isMounted.current) return
        const [trocarFilial, imprimir, engrenagem, semRecalcular, alterarValidade] = await Promise.all([
            permitidoAcaoFuncionalidade("PESQUISAR_ORCAMENTO", "TROCAR_FILIAL"),
            permitidoAcaoFuncionalidade("PESQUISAR_ORCAMENTO", "IMPRIMIR_ORCAMENTO"),
            permitidoAcaoFuncionalidade("ORCAMENTO_ACESSO_ENGRENAGEM_GRID"),
            permitidoAcaoFuncionalidade("PESQUISAR_ORCAMENTO", "ALTERAR_SEM_RECALCULAR_PRECO"), // 455487
            permitidoAcaoFuncionalidade("PESQUISAR_ORCAMENTO", "ALTERAR_VALIDADE_ORCAMENTO"), // 456674
        ])
        if (!isMounted.current) return
        setPermitirTrocarFilial(trocarFilial) // é o botao "tracarFilial"
        setPermitirImprimir(imprimir)
        setPermiteEngrenagemGrid(engrenagem)
        setPermitirAlterarSemRecalcularPreco(semRecalcular)
        setPermitirAlterarValidadeOrcamento(alterarValidade)
    }

    const onObterDadosPesquisaOrcamento = async () => {
        if (!isMounted.current) return
        try {
           globalMU.blockUI()

            const resultado = await microuniversoApi.Orcamento.ObterDadosPesquisaOrcamento();

            if ("Unauthorized" in resultado) {
                renderizarComponentReact(<SenhaVendedorContainerDialog
                    onRenderizarAposAutentificar={() => {
                        removerComponenteReact("botao-perfil-react")
                        renderizarComponentReact(<PesquisaOrcamentoContainer />, "pesquisar-pedidos-region", true)
                        renderizarComponentReact(<PerfilButtonContainer />, "botao-perfil-react", false)
                    }}
                    onVoltar={() => { }}
                />, "senha-vendedor-container-dialog", true);
                return
            }
         

            if (!isMounted.current) return
            setDadosPesquisaOrcamento(resultado)
            setDadosCarregados(true)
           
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
            globalMU.unblockScreen()
        }
    }

    const obterOidUsuario = async () => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI()
            const [oidUsuario, codigoFilial, oidFilialUsuarioLogado] = await Promise.all([
                microuniversoApi.Usuario.obterOid(),
                microuniversoApi.Usuario.ObterCodigoFilialUsuarioLogado(), // 476918
                microuniversoApi.Usuario.obterOidFilialUsuarioLogado(), // 488824
            ])
            if (!isMounted.current) return
            setOidUsuarioLogado(oidUsuario)
            setCodigoFilialUsuarioLogado(codigoFilial)
            setOidFilialUsuarioLogado(oidFilialUsuarioLogado)
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
        }
        finally {
            globalMU.unblockUI()
        }
    }

    const onRenderizarPesquisaOrcamento = () => renderizarComponentReact(
        <PesquisaOrcamentoContainer
            filtroPesquisaOrcamento={filtroPesquisaOrcamento}
            orcamentoSelecionado={orcamentoSelecionado}
            retornarPesquisar />, "pesquisar-pedidos-region", true
    )

    const onPesquisarCliente = (filtro: Partial<FiltroPesquisaOrcamento>) => {
        renderizarComponentReact(
            <PesquisarClienteContainer
                regiaoRenderizada="pesquisar-pedidos-region" passos={passosInterno.current}
                foraOrcamento={true}
                onVoltar={onRenderizarPesquisaOrcamento} consultar
                onSelecionarClienteCallback={(cliente) => {
                    renderizarComponentReact(<PesquisaOrcamentoContainer
                        filtroPesquisaOrcamento={{ ...filtro, CodigoCliente: cliente.Codigo, NomeCliente: cliente.Nome }} />, "pesquisar-pedidos-region", true)
                }}
            />, "pesquisar-pedidos-region", true)
    }

    const obterDadosIniciaisGrid = async () => {
        if (!isMounted.current || dadosIniciaisGridSolicitados.current) return

        dadosIniciaisGridSolicitados.current = true;
        try {
            const dadosInicias = await microuniversoApi.Seguranca.obterDadosGrid("Orcamento", nomeGrid);
            if (!isMounted.current) return
            setColunas(dadosInicias.Colunas);
            setTamanhoFonte(dadosInicias.TamanhoFonte);
        } catch (e) {
            tratamentoErroPadrao(e);
        }
    };

    const alterarFonte = async (tamanho: number) => {
        if (!isMounted.current) return
        globalMU.blockUI();
        try {
            await microuniversoApi.Usuario.alterarFonte(nomeGrid, tamanho);
            globalMU.unblockUI();
        } catch (e) {
            tratamentoErroPadrao(e);
            globalMU.unblockUI();
        }
    };

    const toggleColunaSelecionada = async (nomeColuna: string, selecionada: boolean) => {
        if (!isMounted.current) return
        let coluna = { ...colunas.find((c) => c.Nome == nomeColuna) };
        coluna.Selecionada = selecionada;

        const colunas_ = substituirItemEmArray(
            colunas,
            (coluna) => coluna.Nome == nomeColuna,
            coluna
        );
        if (!isMounted.current) return
        setColunas(colunas_);
        if (!isMounted.current) return
        await microuniversoApi.Seguranca.atualizarColunasGrid(colunas_, nomeGrid);
    };

    const toggleSelecionarTodasColunas = async (selecionar: boolean) => {
        if (!isMounted.current) return
        const colunas_ = colunas.map(
            (c) => ({ ...c, Selecionada: selecionar } as IColuna)
        );
        if (!isMounted.current) return
        setColunas(colunas_);
        if (!isMounted.current) return
        await microuniversoApi.Seguranca.atualizarColunasGrid( colunas_, nomeGrid );
    };

    const onValidarVendedorOrcamentoUnificado = () => {
        if (!isMounted.current) return
        if (filtroPesquisaOrcamento.VendedorParaOrcamentoUnificado) {
            globalMU.showErrorMessage("O vendedor informado não pode ser utilizado para vendas.<br>Este vendedor é utilizado apenas para orçamentos unificados.");
            return true;
        }
        return false;
    }

    const onEditarOrcamento = async (semRecalcular: boolean) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI();
            globalMU.blockScreen()
            
            setProcessando(true)
            if (!orcamentoSelecionado || !filtroPesquisaOrcamento.PermitidoAlterar) {
                return;
            }
            if (!isMounted.current) return
            if (onValidarVendedorOrcamentoUnificado()) {
                return;
            }
            if (!isMounted.current) return

            const validarFonteReceita = (valorParametroPorFilial("UTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA") == "S" 
                                            && (orcamentoSelecionado?.FonteDeReceita == null || orcamentoSelecionado?.FonteDeReceita == "") )
            
            const data = await microuniversoApi.Orcamento.AutorizarAcoesOrcamento(
                        orcamentoSelecionado?.TipoOrcamento, "ALTERAR", 
                        validarFonteReceita, // 487678
                        orcamentoSelecionado.OidFilial, // 487678
                        orcamentoSelecionado.Filial, // 487678
                    )

            if (!data || "HasErrors" in data) {
                
                setProcessando(false) // so retirar se der erro
                return
            }
            if (!isMounted.current) return
            setFiltroPesquisaOrcamento({ ...filtroPesquisaOrcamento })

            
            $.connection.hub.stop(); // 443858
            globalMU.showProcessingToast("", "Abrindo Orçamento", true)
            let url = "/Orcamento/EditarOrcamento?numeroOrcamento=" + orcamentoSelecionado?.NumeroPedido + "&tipoOrcamento=" + orcamentoSelecionado?.TipoOrcamento + "&XAbaId=" + sessionStorage.getItem('aba_id');
            window.location.href =  url + (semRecalcular ? "&semRecalcular=true" : "") // 455487
            globalMU.showProcessingToast("", "Abrindo Orçamento", true)
        } catch (e) {
            setProcessando(false) // so retirar se der erro
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
            
            globalMU.unblockScreen()
        }
    }

    const onConsultarOrcamento = async () => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI();
            setProcessando(true)
            if (!orcamentoSelecionado) {
                return;
            }
            if (!isMounted.current) return
            if (onValidarVendedorOrcamentoUnificado()) {
                return;
            }

            const data = await microuniversoApi.Orcamento.AutorizarAcoesOrcamento(orcamentoSelecionado?.TipoOrcamento, "CONSULTAR", null, null, null);

            if (!data || "HasErrors" in data) {
                setProcessando(false) // so retirar se der erro
                return
            }
            globalMU.showProcessingToast("", "Abrindo Orçamento", true)
            setFiltroPesquisaOrcamento({ ...filtroPesquisaOrcamento })
            $.connection.hub.stop(); // 443858
            window.location.href = "/Orcamento/ConsultarOrcamento?numeroOrcamento=" + orcamentoSelecionado?.NumeroPedido + "&tipoOrcamento=" + orcamentoSelecionado?.TipoOrcamento + "&XAbaId=" + sessionStorage.getItem('aba_id');
            globalMU.showProcessingToast("", "Abrindo Orçamento", true)
        } catch (e) {
            setProcessando(false) // so retirar se der erro
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onAutorizarDuplicacaoOrcamento = async () => {
        if (!isMounted.current) return
        try {
            setProcessando(true)
            globalMU.blockUI();
 
            const data = await microuniversoApi.Orcamento.AutorizarDuplicacaoOrcamento(orcamentoSelecionado?.NumeroPedido, orcamentoSelecionado?.TipoOrcamento);

            if (!data || data?.HasErrors) {
                setProcessando(false) // so retirar se der erro
                return
            }

            globalMU.showProcessingToast("", "Duplicando Orçamento", true)
            $.connection.hub.stop(); // 443858
            window.location.href = "/Orcamento/DuplicarOrcamento?numeroOrcamento=" + orcamentoSelecionado?.NumeroPedido + "&tipoOrcamento=" + orcamentoSelecionado?.TipoOrcamento + "&XAbaId=" + sessionStorage.getItem('aba_id');

        } catch (e) {
            setProcessando(false) // so retirar se der erro
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onDuplicarOrcamento = async () => {
        if (!isMounted.current) return
        try {
            setProcessando(true)
            globalMU.blockUI();
            if (!filtroPesquisaOrcamento.PermitidoDuplicar) {
                return;
            }

            if (onValidarVendedorOrcamentoUnificado()) {
                return;
            }

            const data = await microuniversoApi.Orcamento.AutorizarAcoesOrcamento(
                        orcamentoSelecionado?.TipoOrcamento, 
                        "DUPLICAR", 
                        null, // 487678
                        null, // 487678
                        null, // 487678
            )

            if (!data || "HasErrors" in data) {
                
                setProcessando(false) // so retirar se der erro
                return
            }

            setFiltroPesquisaOrcamento({ ...filtroPesquisaOrcamento })

            await onAutorizarDuplicacaoOrcamento()

        } catch (e) {
            
            setProcessando(false) // so retirar se der erro
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onCancelarOrcamento = async () => {
        if (!isMounted.current) return

        if (valorParametroPorFilial("TRABALHA_COBRANCA_PIX_PRAZO") == "S" )
        {
            const urlApiEnterprise = valorParametroPorFilial("WEBSERVICE_URL_API_ENTERPRISE")?.trimStart()
            if (!urlApiEnterprise || urlApiEnterprise.trim() == "")
            {
                globalMU.showWarnMessage("Parâmetro de configuração do sistema 'WEBSERVICE_URL_API_ENTERPRISE' não está preenchido.")
                return
            }
            if (!urlApiEnterprise.toLowerCase().startsWith("https://") && !urlApiEnterprise.toLowerCase().startsWith("http://") && !urlApiEnterprise.toLowerCase().startsWith("localhost") )
            {
                globalMU.showWarnMessage("Parâmetro de configuração do sistema 'WEBSERVICE_URL_API_ENTERPRISE' está inválido. Deve iniciar com http:// ou https://")
                return
            }
        }
            
        
        try {
            globalMU.blockUI();
            if (!orcamentoSelecionado) {
                return;
            }

            let ehGerente = vendedorGerente
            if (ehGerente == null)
            {
                const vendedor = await microuniversoApi.Vendedor.ObterVendedorAutenticado()
                const dados = await microuniversoApi.Vendedor.vendedorGerente(vendedor.Codigo)
                setVendedorGerente(dados.Gerente)
                ehGerente = dados.Gerente
            }
            if (!ehGerente)
            {
                globalMU.showWarnMessage("Operação não permitida!<br>Somente gerente pode cancelar orçamentos")
                return 
            }

            if (orcamentoSelecionado?.VendaRepresentacao && orcamentoSelecionado?.CodigoSituacaoVenda === "2") // 2-> faturado - PA 456252
            {
                globalMU.showWarnMessage("Pedido de vendas por representação já faturado não pode ser cancelado por essa opção.") // 456252
                return 
            }

            if (!isMounted.current) return 
            setFiltroPesquisaOrcamento({ ...filtroPesquisaOrcamento })

            renderizarComponentReact(
                <CancelarOrcamentoContainer onRemover={() => removerComponenteReact("pesquisar-pedidos-region")}
                    orcamentoSelecionado={orcamentoSelecionado}
                    onVoltar={onRenderizarPesquisaOrcamento} passos={passosInterno.current}
                />, "pesquisar-pedidos-region", true
            )

        } catch (e) {
            setProcessando(false) // so retirar se der erro
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onAlterarValidadeOrcamento = async () => {
        try {
            globalMU.blockUI();
            setProcessando(true)

            if (!orcamentoSelecionado) {
                return;
            }
            if (!isMounted.current) return
            setFiltroPesquisaOrcamento({ ...filtroPesquisaOrcamento})
            if (!isMounted.current) return
            renderizarComponentReact(
                <AlterarValidadePedidoContainer 
                    onRemover={
                        () => removerComponenteReact("pesquisar-pedidos-region")
                    }
                    orcamentoSelecionado={orcamentoSelecionado}
                    onVoltar={onRenderizarPesquisaOrcamento} passos={passosInterno.current}
                />, "pesquisar-pedidos-region", true
            )

        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            setProcessando(false)
            globalMU.unblockUI();
        }
    }

    const onTrocarFilialOrcamento = async () => {
        try {
            globalMU.blockUI();
            setProcessando(true)

            if (!orcamentoSelecionado) {
                return;
            }

            if (filtroPesquisaOrcamento.TipoOrcamentoNovo !== 'Venda') {
                return;
            }
            if (!isMounted.current) return
            if (onValidarVendedorOrcamentoUnificado()) {
                return;
            }

            if (orcamentoSelecionado?.CodigoSituacaoVenda != "A" && valorParametroPorFilial("SOLICITAR_SENHA_TROCA_FILIAL_ORCAMENTO") === "S") {
                globalMU.showWarnMessage("Troca de filial é permitida somente para orçamento com situação APENAS EM ORÇAMENTO.")
                return;
            }
            if (!isMounted.current) return
            setFiltroPesquisaOrcamento({ ...filtroPesquisaOrcamento})

            renderizarComponentReact(
                <TrocarFilialOrcamentoContainer onRemover={() => removerComponenteReact("pesquisar-pedidos-region")}
                    orcamentoSelecionado={orcamentoSelecionado}
                    onVoltar={onRenderizarPesquisaOrcamento} passos={passosInterno.current}
                />, "pesquisar-pedidos-region", true
            )

        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            setProcessando(false)
            globalMU.unblockUI();
        }
    }

    const onLimparCliente = () => {
        if (!isMounted.current) return
        setFiltroPesquisaOrcamento({ ...filtroPesquisaOrcamento, CodigoCliente: '', NomeCliente: '' })
    }

    const onPesquisar = async (filtros: Partial<FiltroPesquisaOrcamento>) => {
        if (!isMounted.current) return
        try {
            setProcessando(true)
            globalMU.blockUI();
            globalMU.blockScreen()
            setFiltroPesquisaOrcamento({ ...filtros})
            const filtroAlterado = { ...filtros, NumeroPagina: filtros.NumeroPagina ?? 1, TamanhoPagina: 20 }
            if (filtroAlterado.NumeroPedido > 0 && filtroAlterado.NumeroPedido != 7)
            {
                //filtroAlterado.ObrigarFiltrarFilial = !permitirTrocarFilial || dadosPesquisaOrcamento.Filiais?.length <= 1; // 456986
                filtroAlterado.ObrigarFiltrarFilial = dadosPesquisaOrcamento.Filiais?.length <= 1; // 456986
                filtroAlterado.ObrigarFiltrarVendedor = dadosPesquisaOrcamento.Vendedores?.length <= 1; // 456986
            }

            const resultado = await microuniversoApi.Orcamento.PesquisarOrcamento(filtroAlterado);
            
            if (!isMounted.current) return
            if (resultado?.PageMessage?.Entities?.filter(e => e.NumeroPedido == props.orcamentoSelecionado?.NumeroPedido)?.length == 1 ) {
                setOrcamentoSelecionado((resultado.PageMessage?.Entities ?? []).find(e => e.NumeroPedido == props.orcamentoSelecionado.NumeroPedido));
            } else {
                !props.orcamentoSelecionado && setOrcamentoSelecionado(null)
            }
            if (resultado?.PageMessage?.RowsCount == 1)
             { // se retornou apenas um orçamento, seleciona ele automaticamente
                setProcessando(false) // para deixar selecionar o orçamento
             }
             if (!isMounted.current) return
            setDadosPesquisa(resultado)
            tableRef.current?.scrollIntoView({ behavior: "smooth" })
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            setProcessando(false)
            globalMU.unblockUI();
            globalMU.unblockScreen();
        }
    }

    const onSelecionarOrcamento = (orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>) => {
        if (processando){
            return // para nao deixar mudar a selecao durante processamento
        }
        if (!isMounted.current) return
        setOrcamentoSelecionado(orcamentoSelecionado);
        if (!isMounted.current) return
        setFiltroPesquisaOrcamento({
            ...filtroPesquisaOrcamento,
            TipoOrcamentoNovo: orcamentoSelecionado?.TipoOrcamento,
            PermiteTrocarFilial: orcamentoSelecionado?.TipoOrcamento == 'Venda' && (valorParametroPorFilial("SOLICITAR_SENHA_TROCA_FILIAL_ORCAMENTO") === "S"
                && orcamentoSelecionado?.CodigoSituacaoVenda === 'A' ||
                (valorParametroPorFilial("SOLICITAR_SENHA_TROCA_FILIAL_ORCAMENTO") != "S" &&
                    (orcamentoSelecionado?.CodigoSituacaoVenda === '0' || orcamentoSelecionado?.CodigoSituacaoVenda === '1' ||
                        orcamentoSelecionado?.CodigoSituacaoVenda === '5' || orcamentoSelecionado?.CodigoSituacaoVenda === 'A'))),
            PermitidoDuplicar: orcamentoSelecionado?.PermiteDuplicar,
            PermitidoAlterar: orcamentoSelecionado?.PermiteAlterar,
            JustificativaDuplicar: orcamentoSelecionado?.JustificativaDuplicar,
            JustificativaAlterar: orcamentoSelecionado?.JustificativaAlterar
        })
    }

    useMenuConsultasPesquisaOrcamento({
        orcamentoSelecionado: orcamentoSelecionado,
        onVoltar: () => onRenderizarPesquisaOrcamento(),
        passos: passosInterno.current
    })

    const onEditarUltimoOrcamento = async () => {
        try {
            setProcessando(true)
            globalMU.blockUI();
            if (!isMounted.current) return
            const resultado = await microuniversoApi.Orcamento.EditarUltimoOrcamentoVendedor();
            if (!resultado || "HasErrors" in resultado) {
                return
            }
            globalMU.showProcessingToast("", "Abrindo Orçamento",true)

            $.connection.hub.stop(); // 443858
            window.location.href = "/Orcamento/EditarOrcamento?numeroOrcamento=" + resultado.Numero + "&tipoOrcamento=" + resultado.TipoOperacao + "&XAbaId=" + sessionStorage.getItem('aba_id');
            globalMU.showProcessingToast("", "Abrindo Orçamento", true)
            globalMU.blockUI();

        } catch (e) {
            setProcessando(false) // so retirar se der erro
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onImprimirOrcamento = () => {
        if (!isMounted.current) return
        try {
            orcamentoSelecionado?.PermiteImprimir 
                ? setMostrarModalImprimir(true) 
                : globalMU.showInfoMessage("Situação do orçamento impede que seja impresso");
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const filtrosTemplates: FiltrosListarTemplateSeguranca = {
        token: encodeURIComponent(token),
        codigoUsuario: oidUsuarioLogado,
        siglaFuncionalidade: "PESQUISAR_ORCAMENTO",
        siglaAcao: "IMPRIMIR_ORCAMENTO",
        codigoFilial: orcamentoSelecionado?.Filial ?? "null", // 455683
    };

    useEffect(() => {
         globalMU.blockScreen()
         obterOidUsuario()
         return () => {
            isMounted.current = false
        }
    }, [])

    useEffect(() => {
        
        if (!isMounted.current) return
        if (oidFilialUsuarioLogado > 0)
            {
                
                const executarFuncoes = async () =>               
                {
                    
                    await Promise.all([
                        // 488824 - buscarPermissaoFuncionalidadeAcao(),
                        // 488824 - obterOidUsuario(),
                        // 488824 - obterPermissaoImpressao(),
                        atualizarParametros(),
                        atualizarParametrosPorFilial(), // 450413
                        onObterDadosPesquisaOrcamento(),
                    ])
                }

            executarFuncoes()
            if (!isMounted.current) return
            passosInterno.current.set("Pesquisa de Orçamento", () => onRenderizarPesquisaOrcamento())
            props.retornarPesquisar && onPesquisar(props.filtroPesquisaOrcamento)
        }
        

    }, [oidFilialUsuarioLogado])

    useEffect(() => {
        if (dadosPesquisa?.PageMessage?.RowsCount == 1)
        { // se retornou apenas um orçamento, seleciona ele automaticamente
            if (!isMounted.current) return
            onSelecionarOrcamento(dadosPesquisa.PageMessage?.Entities?.[0])
        }
        }, [dadosPesquisa])

    useEffect(() => {
        if (!isMounted.current) return
        var controleExclusividadePesquisaOrcamentosHub = $.connection.controleExclusividadePesquisaOrcamentosHub
        controleExclusividadePesquisaOrcamentosHub.client.pong = () => {
            console.log('controleExclusividadePesquisaOrcamentosHub => pong')
        }
        $.connection.hub.start().done(function () {
            controleExclusividadePesquisaOrcamentosHub.server.ping()
        })
    }, [])

    useEffect(() => {
        if (!isMounted.current) return
        atualizarParametrosPorFilial()
    },[orcamentoSelecionado])

    useEffect(() => { // 450413
        if (!isMounted.current) return
        if (parametrosPorFilial != null && parametrosPorFilial.length > 0)
        {
            const senhaSolicitarConst = valorParametroPorFilial("SOLICITAR_AUTORIZACAO_IMPRESSAO_ORCAMENTO_DESCONTO_ACIMA_PERMITIDO") == "S" && orcamentoSelecionado?.PossuiPendenciaDesconto ? "TIPO_LIBERACAO_LIBORCDESCONTO" : undefined // 450413
            const senhaSolicitarDicaConst = valorParametroPorFilial("SOLICITAR_AUTORIZACAO_IMPRESSAO_ORCAMENTO_DESCONTO_ACIMA_PERMITIDO") == "S" && orcamentoSelecionado?.PossuiPendenciaDesconto ? "Permissao: [Permitir imprimir orçamentos com desconto acima do permitido]" : undefined
            const senhaTextoAdicionalConst = valorParametroPorFilial("SOLICITAR_AUTORIZACAO_IMPRESSAO_ORCAMENTO_DESCONTO_ACIMA_PERMITIDO") == "S" && orcamentoSelecionado?.PossuiPendenciaDesconto ?"Pedido Possui Pendência de Desconto" : undefined
            if (!isMounted.current) return
            setPermissaoSenhaModalImprimir({ // 450413
                senhaSolicitar: senhaSolicitarConst,
                senhaSolicitarDica: senhaSolicitarDicaConst,
                senhaTextoAdicional: senhaTextoAdicionalConst
            })
        }
    }, [parametrosPorFilial]) // 450413

    return (
        <>
            {dadosCarregados &&
                <>
                    <Breadcrumb2Container
                        passos={passosInterno?.current?.keysToList()}
                        exibirBotaoLimpar={false}
                        exibirBotaoVoltar={false}
                        processando={processando}
                        id="PesquisarOrcamentoContainer"
                    />

                    <PesquisaOrcamento
                        processando={processando}
                        dadosPesquisaOrcamento={dadosPesquisaOrcamento}
                        filtroPesquisaOrcamento={filtroPesquisaOrcamento}
                        vendedor={dadosPesquisaOrcamento.VendedorLogado}
                        codigoFilialUsuarioLogado={codigoFilialUsuarioLogado} // 476918
                        colunas={colunas}
                        tableRef={tableRef}
                        tamanhoFontePadrao={tamanhoFonte}
                        dadosPesquisa={dadosPesquisa}
                        permitirImprimirOrcamento={permitirImprimir}
                        permitirTrocarFilial={permitirTrocarFilial} // é o botao "tracarFilial"
                        permiteEngrenagemGrid={permiteEngrenagemGrid}
                        permitirAlterarSemRecalcularPreco={permitirAlterarSemRecalcularPreco} // 455487
                        permitirAlterarValidadeOrcamento={permitirAlterarValidadeOrcamento} // 456674
                        orcamentoSelecionado={orcamentoSelecionado}
                        corSelecionada={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
                        textoSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
                        habilitarDuplicacaoOrcamento={valorParametroPorFilial("HABILITAR_DUPLICACAO_ORCAMENTO") == "S"}
                        usuarioPedeSenhaACadaOrcamento={valorParametro("PEDE_SENHA_A_CADA_ORCAMENTO") == "S"}
                        destacarPendenciaEstoqueConsultaOrcamento={valorParametro("DESTACAR_PENDENCIA_ESTOQUE_CONSULTA_ORCAMENTO") == "S"}
                        exibirOrcamentosUnificadosConsulta={valorParametro("EXIBIR_ORCAMENTOS_UNIFICADOS_CONSULTA_ORC") == "S"}
                        exibirSituacaoConferencia={valorParametroPorFilial("UTILIZA_CODBARRA_CONFERENCIA_SAIDA") == "S"}
                        onPesquisarCliente={onPesquisarCliente}
                        onAlterarOrcamento={onEditarOrcamento}
                        onDuplicarOrcamento={onDuplicarOrcamento}
                        onConsultarOrcamento={onConsultarOrcamento}
                        onCancelarOrcamento={onCancelarOrcamento}
                        onTrocarFilialOrcamento={onTrocarFilialOrcamento}
                        onAlterarValidadeOrcamento={onAlterarValidadeOrcamento} // 456674
                        onAlterarFonte={alterarFonte}
                        onToggleColunaSelecionada={toggleColunaSelecionada}
                        onToggleSelecionarTodasColunas={toggleSelecionarTodasColunas}
                        onLimparCliente={onLimparCliente}
                        onPesquisar={async (filtro) => {
                            const filtroPesquisa = { ...filtro, NumeroPagina: 1 };

                            if (colunas.length === 0 && !dadosIniciaisGridSolicitados.current) {
                                await Promise.all([
                                    buscarPermissaoFuncionalidadeAcao(), // 488824
                                    obterDadosIniciaisGrid(), // 488824
                                    obterPermissaoImpressao(), // 488824
                                    onPesquisar(filtroPesquisa),
                                ]);
                                return;
                            }

                            await onPesquisar(filtroPesquisa)
                        }}
                        onSelecionarOrcamento={onSelecionarOrcamento}
                        onEditarUltimoOrcamento={onEditarUltimoOrcamento}
                        onPesquisarPaginada={(filtro) => onPesquisar(filtro)}
                        onErrorValidacao={(erroFormulario) => globalMU.showErrorMessage(erroFormulario)}
                        onImprimirOrcamento={onImprimirOrcamento}
                        onMostrarJustificativaAlterar={(alerta) => globalMU.showInfoMessage(alerta)}
                        onMostrarJustificativaDuplicar={(alerta) => globalMU.showInfoMessage(alerta)}
                    />

                    {mostrarModalImprimir &&
                    <ModalImprimirContainer
                        filtrosTemplates={filtrosTemplates}
                        nomeArquivoWord={"ORC" + orcamentoSelecionado?.NumeroPedido + ".doc"}
                        urlBase="/Relatorio/Orcamento"
                        parametrosTemplate={[
                            {
                                nome: "id",
                                valor: [orcamentoSelecionado?.NumeroPedido],
                            },
                        ]}
                        idOrcamento={orcamentoSelecionado?.NumeroPedido}
                        permissaoSenhaModalImprimir={permissaoSenhaModalImprimir} // 450413
                        exibirModalImprimir={mostrarModalImprimir}
                        onClose={() => setMostrarModalImprimir(false)}
                        permissoes={permissoesImpressao}
                    />
                    }
                </>
            }
        </>
    )
}

window.PesquisaOrcamentoContainer = PesquisaOrcamentoContainer
